import React from 'react';
import './CookieBanner.css';

function CookieBanner({ consentGiven, giveCookieConsent }) {
    console.log('CookieBanner render, consentGiven:', consentGiven);
  if (consentGiven) return null;

  return (
    <div className="cookie-banner">
      <p>Questo sito utilizza cookie per migliorare l'esperienza utente. Continuando accetti l'uso dei cookie.</p>
      <button onClick={giveCookieConsent}>Accetta</button>
    </div>
  );
}

export default CookieBanner;
